import React, { useState } from 'react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [modal, setModal] = useState<ModalType>(null);
  return <>
      <footer className="w-full pt-16 pb-8" style={{
      backgroundColor: '#000000',
      borderTop: '1px solid rgba(201,168,76,0.2)'
    }} role="contentinfo" data-id="element-47">
        <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-48">
          {/* Main footer content */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-10 mb-12" data-id="element-49">
            {/* Logo + tagline */}
            <div className="sm:col-span-1" data-id="element-50">
              <img src="https://cdn.magicpatterns.com/uploads/goqK8pHAvhVgWADmkNvCK7/logobyguerra.png" alt="By Guerra BarberShop" className="h-14 w-auto object-contain mb-4" data-id="element-51" />
              <p style={{
              fontFamily: 'var(--font-heading)',
              fontSize: '0.95rem',
              fontStyle: 'italic',
              color: '#888',
              lineHeight: 1.6
            }} data-id="element-52">
                Walk in looking regular. Walk out looking like money.
              </p>
            </div>

            {/* Contact */}
            <div data-id="element-53">
              <h3 style={{
              fontFamily: 'var(--font-callout)',
              fontSize: '0.75rem',
              letterSpacing: '0.2em',
              textTransform: 'uppercase',
              color: '#C9A84C',
              marginBottom: '1rem'
            }} data-id="element-54">
                Contact
              </h3>
              <div className="space-y-3" data-id="element-55">
                <a href="tel:7865364035" className="flex items-center gap-3 transition-opacity hover:opacity-80" data-id="element-56">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-57">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.38 2 2 0 0 1 3.58 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.56a16 16 0 0 0 6.29 6.29l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" data-id="element-58" />
                  </svg>
                  <span style={{
                  fontFamily: 'var(--font-body)',
                  fontSize: '0.9rem',
                  color: '#aaa'
                }} data-id="element-59">
                    (786) 536-4035
                  </span>
                </a>
                <a href="https://maps.google.com/?q=3300+W+84th+St+Hialeah+FL+33018" target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 transition-opacity hover:opacity-80" data-id="element-60">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-61">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" data-id="element-62" />
                    <circle cx="12" cy="10" r="3" data-id="element-63" />
                  </svg>
                  <span style={{
                  fontFamily: 'var(--font-body)',
                  fontSize: '0.9rem',
                  color: '#aaa',
                  lineHeight: 1.5
                }} data-id="element-64">
                    3300 W 84th St
                    <br data-id="element-65" />
                    Hialeah, FL 33018
                  </span>
                </a>
              </div>
            </div>

            {/* Hours */}
            <div data-id="element-66">
              <h3 style={{
              fontFamily: 'var(--font-callout)',
              fontSize: '0.75rem',
              letterSpacing: '0.2em',
              textTransform: 'uppercase',
              color: '#C9A84C',
              marginBottom: '1rem'
            }} data-id="element-67">
                Hours
              </h3>
              <div className="space-y-2" data-id="element-68">
                <div className="flex items-center gap-3" data-id="element-69">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-70">
                    <circle cx="12" cy="12" r="10" data-id="element-71" />
                    <polyline points="12 6 12 12 16 14" data-id="element-72" />
                  </svg>
                  <span style={{
                  fontFamily: 'var(--font-body)',
                  fontSize: '0.9rem',
                  color: '#aaa'
                }} data-id="element-73">
                    Open Daily Until 8PM
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-74">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-75">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" data-id="element-76" />
                    <circle cx="9" cy="7" r="4" data-id="element-77" />
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87" data-id="element-78" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" data-id="element-79" />
                  </svg>
                  <span style={{
                  fontFamily: 'var(--font-body)',
                  fontSize: '0.9rem',
                  color: '#aaa'
                }} data-id="element-80">
                    Walk-Ins Always Welcome
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-81">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-82">
                    <polyline points="20 6 9 17 4 12" data-id="element-83" />
                  </svg>
                  <span style={{
                  fontFamily: 'var(--font-body)',
                  fontSize: '0.9rem',
                  color: '#C9A84C',
                  fontWeight: 500
                }} data-id="element-84">
                    Open Now
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Gold divider */}
          <div className="gold-divider-full mb-8" data-id="element-85" />

          {/* Bottom bar */}
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-86">
            <p style={{
            fontFamily: 'var(--font-body)',
            fontSize: '0.8rem',
            color: '#444'
          }} data-id="element-87">
              © {new Date().getFullYear()} By Guerra BarberShop · Paraíso Plaza
              2 · Hialeah, FL
            </p>
            <div className="flex items-center gap-4" data-id="element-88">
              <button onClick={() => setModal('privacy')} className="transition-opacity hover:opacity-80" style={{
              fontFamily: 'var(--font-body)',
              fontSize: '0.8rem',
              color: '#555',
              textDecoration: 'underline',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 0
            }} data-id="element-89">
                Privacy Policy
              </button>
              <span style={{
              color: '#333'
            }} data-id="element-90">
                ·
              </span>
              <button onClick={() => setModal('terms')} className="transition-opacity hover:opacity-80" style={{
              fontFamily: 'var(--font-body)',
              fontSize: '0.8rem',
              color: '#555',
              textDecoration: 'underline',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 0
            }} data-id="element-91">
                Terms of Service
              </button>
              <span style={{
              color: '#333'
            }} data-id="element-92">
                ·
              </span>
              <p style={{
              fontFamily: 'var(--font-heading)',
              fontSize: '0.8rem',
              fontStyle: 'italic',
              color: '#444'
            }} data-id="element-93">
                Excellence guaranteed.
              </p>
            </div>
          </div>
        </div>
      </footer>

      {/* Legal Modal */}
      {modal && <LegalModal type={modal} onClose={() => setModal(null)} data-id="element-94" />}
    </>;
}
function LegalModal({
  type,
  onClose
}: {
  type: 'privacy' | 'terms';
  onClose: () => void;
}) {
  const isPrivacy = type === 'privacy';
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" style={{
    backgroundColor: 'rgba(0,0,0,0.85)',
    backdropFilter: 'blur(6px)'
  }} onClick={e => {
    if (e.target === e.currentTarget) onClose();
  }} role="dialog" aria-modal="true" aria-label={isPrivacy ? 'Privacy Policy' : 'Terms of Service'} data-id="element-95">
      <div className="relative w-full max-w-2xl max-h-[80vh] overflow-y-auto rounded-sm" style={{
      backgroundColor: '#111111',
      border: '1px solid rgba(201,168,76,0.3)'
    }} data-id="element-96">
        {/* Modal header */}
        <div className="sticky top-0 flex items-center justify-between px-6 py-5" style={{
        backgroundColor: '#111111',
        borderBottom: '1px solid rgba(201,168,76,0.2)'
      }} data-id="element-97">
          <div className="flex items-center gap-3" data-id="element-98">
            <div style={{
            width: '24px',
            height: '1px',
            background: '#C9A84C'
          }} data-id="element-99" />
            <h2 style={{
            fontFamily: 'var(--font-callout)',
            fontSize: '1rem',
            fontWeight: 600,
            color: '#F5F5F5',
            letterSpacing: '0.08em',
            textTransform: 'uppercase'
          }} data-id="element-100">
              {isPrivacy ? 'Privacy Policy' : 'Terms of Service'}
            </h2>
          </div>
          <button onClick={onClose} className="flex items-center justify-center w-8 h-8 rounded-sm transition-opacity hover:opacity-70" style={{
          border: '1px solid rgba(201,168,76,0.3)'
        }} aria-label="Close" data-id="element-101">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-102">
              <line x1="18" y1="6" x2="6" y2="18" data-id="element-103" />
              <line x1="6" y1="6" x2="18" y2="18" data-id="element-104" />
            </svg>
          </button>
        </div>

        {/* Modal content */}
        <div className="px-6 py-6 space-y-5" style={{
        fontFamily: 'var(--font-body)',
        fontSize: '0.9rem',
        color: '#aaa',
        lineHeight: 1.8
      }} data-id="element-105">
          {isPrivacy ? <>
              <p style={{
            color: '#888',
            fontSize: '0.8rem'
          }} data-id="element-106">
                Last updated: {new Date().getFullYear()}
              </p>
              <Section title="Information We Collect" data-id="element-107">
                We collect information you provide directly to us, such as your
                name and phone number when you contact us or book a service. We
                may also collect information automatically when you visit our
                website, including your IP address and browser type.
              </Section>
              <Section title="How We Use Your Information" data-id="element-108">
                We use the information we collect to provide, maintain, and
                improve our services, communicate with you about appointments
                and promotions, and comply with legal obligations.
              </Section>
              <Section title="Information Sharing" data-id="element-109">
                We do not sell, trade, or rent your personal information to
                third parties. We may share your information with trusted
                service providers who assist us in operating our business,
                subject to confidentiality agreements.
              </Section>
              <Section title="Data Security" data-id="element-110">
                We implement appropriate security measures to protect your
                personal information. However, no method of transmission over
                the Internet is 100% secure.
              </Section>
              <Section title="Contact Us" data-id="element-111">
                If you have questions about this Privacy Policy, please contact
                us at (786) 536-4035 or visit us at Paraíso Plaza 2, 3300 W 84th
                St, Hialeah, FL 33018.
              </Section>
            </> : <>
              <p style={{
            color: '#888',
            fontSize: '0.8rem'
          }} data-id="element-112">
                Last updated: {new Date().getFullYear()}
              </p>
              <Section title="Acceptance of Terms" data-id="element-113">
                By visiting or using our services at By Guerra BarberShop, you
                agree to be bound by these Terms of Service. If you do not agree
                to these terms, please do not use our services.
              </Section>
              <Section title="Services" data-id="element-114">
                By Guerra BarberShop provides professional barbering and
                grooming services. We reserve the right to refuse service to
                anyone for any reason at any time. All services are subject to
                availability.
              </Section>
              <Section title="Appointments & Walk-Ins" data-id="element-115">
                We proudly accept walk-in clients during business hours (open
                until 8PM daily). We are not responsible for wait times during
                peak hours. We reserve the right to modify our hours of
                operation.
              </Section>
              <Section title="Payment" data-id="element-116">
                Payment is due at the time of service. We accept cash and major
                credit cards. Prices are subject to change without notice.
              </Section>
              <Section title="Satisfaction Guarantee" data-id="element-117">
                We stand behind our work. If you are not satisfied with your
                service, please notify us before leaving and we will make it
                right at no additional charge.
              </Section>
              <Section title="Limitation of Liability" data-id="element-118">
                By Guerra BarberShop shall not be liable for any indirect,
                incidental, or consequential damages arising from the use of our
                services.
              </Section>
              <Section title="Contact" data-id="element-119">
                For questions about these Terms, contact us at (786) 536-4035 or
                visit Paraíso Plaza 2, 3300 W 84th St, Hialeah, FL 33018.
              </Section>
            </>}
        </div>
      </div>
    </div>;
}
function Section({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div data-id="element-120">
      <h3 style={{
      fontFamily: 'var(--font-callout)',
      fontSize: '0.85rem',
      fontWeight: 600,
      color: '#C9A84C',
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      marginBottom: '0.5rem'
    }} data-id="element-121">
        {title}
      </h3>
      <p data-id="element-122">{children}</p>
    </div>;
}